import React from "react";
// import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
import { Grid } from "@mui/material";
// import UnpaidInvoicesListingTable from "./UnpaidInvoicesListingTable";
import UnpaidInvoicesNewList from "./UnpaidInvoicesNewList";

function UnpaidInvoicesListing() {
  // const navigate = useNavigate();
  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Unpaid Invoices</h1>
            {/* <Button
              className="contentTopLefBt addCommiteeBt"
              onClick={() => navigate("/CreateInvoice")}
            >
              Create New Invoice
            </Button> */}
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              {/* <UnpaidInvoicesListingTable /> */}
              <UnpaidInvoicesNewList />
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default UnpaidInvoicesListing;
